import { useListProducts, type ListProductResponse } from '../api/listProducts';
import { useProductStore } from 'shared/products/stores/productStore';
import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefereshProductStore = defineStore('refresh-products', () => {
  const listProducts = useListProducts();
  const store = useProductStore();

  return useRefreshStore<ListProductResponse>({
    fetchFromServer() {
      return listProducts.execute();
    },
    mergeToStore(response) {
      store.merge(response.products);
    },
  });
});
